export const debug = false;

export const firebaseConfig = {
    apiKey: "AIzaSyBcUzuTWTsPWlD6eGmLZI7Bm3QyxhTcToc",
    authDomain: "cataloga.me",
    projectId: "catalogs-f707e",
    storageBucket: "catalogs-f707e.appspot.com",
    messagingSenderId: "1073990895256",
    appId: "1:1073990895256:web:b53d0cae29a3a92c66b2ed",
    measurementId: "G-5W9SWJXKNW"
};

export const algoliaConfig = {
    appId: '8HWH4U40AA',
    searchApiKey: '9dad0444b6a85c4882f36a714368bb58',
    indexName: 'products_index'
};

export const accentColor = "mdl-color--yellow-200";

export const countries =   {    "ar":   {   "name":"Argentina" },
                                "bo":   {   "name":"Bolivia" },
                                "cl":   {   "name":"Chile" },
                                "co":   {   "name":"Colombia" },
                                "cr":   {   "name":"Costa Rica" },
                                "cu":   {   "name":"Cuba" },
                                "ec":   {   "name":"Ecuador" },
                                "sv":   {   "name":"El Salvador" },
                                "es":   {   "name":"España" },
                                "us":   {   "name":"Estados Unidos" },
                                "gt":   {   "name":"Guatemala" },
                                "gf":   {   "name":"Guyana" },
                                "hn":   {   "name":"Honduras" },
                                "jm":   {   "name":"Jamaica" },
                                "mx":   {   "name":"México" },
                                "pa":   {   "name":"Panamá" },
                                "py":   {   "name":"Paraguay" },
                                "pe":   {   "name":"Perú" },
                                "do":   {   "name":"República Dominicana" },
                                "sr":   {   "name":"Surinam" },
                                "tt":   {   "name":"Trinidad y Tobago" },
                                "uy":   {   "name":"Uruguay" },
                                "ve":   {   "name":"Venezuela"},
                    } //https://www.ionos.com/es-us/digitalguide/dominios/extensiones-de-dominio/cctld-la-lista-completa-de-dominios-por-pais/

export const freePlan = "20";       // No eliminar. Es el valor por defecto para la creación de nuevos catálogos

export const textFor = {
    "name": "Nombre", "prices": "Precios", "price": "Precio", "currency": "Moneda", "info": "Información", "showName": "Mostrar el Nombre",
    "attributes": "Atributos", "attribute": "Atributo", "number": "Sólo aceptar números", "uom": "Unidad de medida (opcional)", "visible": "Visible para todos",
    "brands": "Marcas", "brand": "Marca", "categories": "Categorías", "category": "Categoría", "collections": "Colecciones", "collection": "Colección", "variant":"Variante",
    "option": "Filtro", "preferences":"Preferencias", "warehouse":"Almacén", "warehouses":"Almacenes", "kardex":"Existencias", "date":"Fecha", "operation":"Operación",
    "quantity":"Cantidad", "from":"Del almacén","to":"Al almacén", "note":"Notas", "profile":"Perfil", "profiles":"Perfiles","showDetailedAva":"Mostrar existencia por almacén", 
    "showTotalAva":"Mostrar existencia total", "hideUnavailable":"Ocultar productos no disponibles", "public":"Público", "admin":"Administrador","showTitle":"Mostrar título en el menú",
    "userName":"Usuario", "enableAvailability":"Habilitar módulo de existencias","support":"Soporte", "plan":"Plan", "users":"Usuarios", "userArea":"Mi Perfil",
    "suscribeCat":"Afiliarme a este catálogo", "enableWhatsapp": "Habilitar módulo WhatsApp", "enableMenu": "Modo Menú", "enableOrders":"Habilitar Pedidos",
    "modifier":"Opción", "maximun":"Máximo de Opciones Permitidas", "allowOrders":"Permitir Pedidos", "minimun":"Mínimo de Opciones Permitidas", 
    "orderPrice":"Precio predeterminado en pedidos","isURL":"Manejar como URL", "orderChannel":"Medio de envío predeterminado para pedidos", 
    "enableInfoField": "Habilitar campo de información para pedidos", "orderLabel":"Etiqueta para campo de pedidos", "orderInfo":"Información adicional para pedidos",
    "showCatHome":"Mostrar las categorías al inicio","linkToPrice":"Vincular con", "factor1":"Factor Multiplicador 1", "factor2":"Factor Multiplicador 2",
    "isSale":"Oferta", "enableLink":"Habilitar vínculación de precio", "thumbnail":"Imagen para el botón de la categoría" , "label":"Imagen  de la marca",
    "smartLoad": "Carga Inteligente", "product":"Producto", "orderName":"Identificador", "features": "Características"};

export const dbStructure = {   
    "attribute":{"name":"string","number":"boolean","uom":"string","visible":"boolean","isURL":"boolean"},
    "brand":{"name":"string","label":"string"},
    "collection":{"category":"array","name":"string","showTitle":"boolean"},
    "category":{"name":"string","option":"array", "thumbnail":"string"},
    "price":{"currency":"string","info":"string","name":"string","showName":"boolean","linkToPrice":"string","factor1":"number","factor2":"number",
        "isSale":"boolean", "enableLink":"boolean"},
    "product":{"active": "boolean", "attribute": "object", "availability":"object", "barcode": "string", "brand": "string", "category": "string", 
        "description": "string", "featured":"boolean", "imgURL": "array", "kardex":"array", "model": "string", "notes": "string", 
        "option": "array", "price": "object", "sku": "string", "title": "string", "variant":"array" },
    "profile":{"collection":"array","name":"string","price":"array","showDetailedAva":"boolean","showTotalAva":"boolean","hideUnavailable":"boolean",
            "allowOrders":"boolean","orderPrice":"string", "orderChannel":"string"},
    "warehouse":{"name":"string"},
    "variant":{"name":"string","modifier":"object","maximun":"number","minimun":"number","category":"array"},
    "catalog":{"active":"boolean", "activeDate": "object", "activePaymentTerm":"string" ,"activePlan":"string", "admin":"array", "allowOrders": "boolean", 
        "contact":"object", "country":"string", "enableAvailability":"boolean", "enableWhatsApp":"boolean", "expirationDate":"object", 
        "faviconURL":"string", "homeBanner":"object","homeProductsOrder":"array","id":"string", "logoURL":"string", "maxKardex":"string", "menuMode":"boolean", 
        "name":"string", "orderChannel":"string", "orderInfo":"string", "orderLabel":"string", "orderName":"string", "orderPrice":"string", "startDate": "object", 
        "superadmin":"array", "tokenQuota":"object", "style":"object"},
    // The following ones are for catalogs ...
    "contact":{"address":"string", "city":"string", "phone":"string", "whatsapp":"string", "orderEmail":"string"},
    "homeBanner":{"mobileUrl":"array", "url":"array"},
    "style":{"accentColor":"string", "backgroundColor":"string", "primaryColor":"string"},
    "tokenQuota":{"available":"number", "limit":"number"}
    }; 

export const supportEmails = ["catalogaoficial@gmail.com"];

export const videosData = [
    {   "name": "<b> Ver toda la lista de reprodución </b>",
        "time": "23:56",
        "url":"https://youtube.com/playlist?list=PLtNsdJCdQrEvZGuc0CQBnXdMHp6Ndwd82&si=vouK6oeTpFThw270"    },    
    {   "name": "Guía rápida: Cómo registrar tu primer catálogo digital",
        "time": "1:39",
        "url":"https://youtu.be/MvVGxdc0QPc?si=fFjOdH53QRs9PlUj"    },
    {   "name": "Una interfaz para todos: Simplifica la gestión de tu catálogo digital",
        "time": "1:39",
        "url": "https://youtu.be/uADMfO2OUmk?si=HZJSSclhXt2m-T_o"   },
    {   "name": "¡Dale un toque personal a tu catálogo! Guía completa de personalización",
        "time": "4:26",
        "url": "https://youtu.be/vfQAkKP6Cxo?si=kztE699w_miumhyp"   },
    {   "name": "Estructura tu catálogo para una mejor experiencia de usuario ¡Paso a paso!",
        "time": "2:06",
        "url": "https://youtu.be/CpkxiBTX3vQ?si=iMzXSNSnVrVnqXof"   },
    {   "name": "Prepara tu catálogo para vender: ¡Todo lo que necesitas saber! Marcas, precios y atributos",
        "time": "2:42",
        "url": "https://youtu.be/wAMcag6y2Xo?si=fWv9kVlbKMm9whHB"   },
    {   "name": "Guía completa para crear tu catálogo: Añade productos en minutos!",
        "time": "2:45",
        "url": "https://youtu.be/vaOjdpASMJE?si=pGIh_y4Q1K6olTCS"   },
    {   "name": "Facilita las búsquedas de productos a tus clientes: Crea filtros personalizados",
        "time": "3:14",
        "url": "https://youtu.be/A3nnlykJzBg?si=i1kQcL0b4nXn20hT"   },
    {   "name": "¡Nunca más te quedes sin stock! Gestiona existencias en múltiples almacenes",
        "time": "3:01",
        "url": "https://youtu.be/s5GhUjTUMbY?si=Lkgkl29AV7T4R66j"   },
    {   "name": "Utiliza el mismo catálogo digital para clientes con diferentes perfiles",
        "time": "2:44",
        "url": "https://youtu.be/OWZnZaOYNbE?si=0-sS_GqGKWPG9nAx"}
];

export const maxFreeCatalogs = 2;

export const infoline = 
    `<b>Instrucciones:<b></br>
    <ul>
    <li>La validez de un catálogo o Menú gratis es de un año: publica productos en ese tiempo para mantenerlo activo.</li>
    <li>Si necesitas cambiar el nombre que escogiste, eliminar el catálogo o cancelar una solicitud pendiente, escríbenos a través de la sección 
        <b>Soporte</b> del Catálogo.</li>
    <li>Modifica tu plan de productos, la forma de pago y reporta tus pagos en la sección <b>Soporte</b> del Catálogo.</li>
    <li>Puedes <b>compartir</b> el catálogo o menú con tus clientes mediante el enlace indicado.</li>
    <li><b>Recomendado:</b> ¡Aprende a usar todas las funciones en sólo 24 minutos! 
        <a href="https://youtube.com/playlist?list=PLtNsdJCdQrEvZGuc0CQBnXdMHp6Ndwd82&si=X2pRicD2SIu1pZLq" target="_blank">[Ver tutorial en video]</a>
    </li>
    </ul>`;

export const minimunArray = ["Ninguno","1","2","3","4"];
export const maximunArray = ["Todos","1","2","3","4"];

export const minWidth = {"kardex": 1040, "banner":500};

export const newProductDays = 15;

export const allowedExtensions = ["jpg", "jpeg", "png", "webp"];

export const iaMsg = {
    "infoSmartLoad":`<b>Instrucciones</b><br><br><ul style='padding-left: 20px; margin: 0;'><li><b>Carga una imagen: </b> 
        De un producto, un catálogo o una lista de precios. La IA extraerá la información y te ayudará a alimentar el catálogo.</li><li><b>
        Máximo 30 productos: </b> Sube la información por partes para garantizar la precisión y darte resultados en un tiempo razonable.</li><li style='margin-bottom: 15px;'><b>Opcional</b>: 
        Usa el cuadro de texto para darle contexto a la IA. Si hay precios, explícale cómo asociar los nombres de los precios de tu catálogo con los del archivo y cómo calcularlos.
        En el caso de que sólo quieras actualizar los precios, dile (para que no te sugiera títulos/descripciones y procese más rápido).  </li></ul>`,
    "aiSuccess1": "<b>Archivo cargado con éxito:</b> Estoy analizando tu archivo y revisando lo que hay en tu catálogo. <br><b>Ten un poco de paciencia</b>: dependiendo del volumen, este análisis puede tomar un par de minutos.",
    "aiSuccess2": `<div style='color:red; font-weight: bold; font-style: italic; text-align: center;'><i class='material-icons' style='color:Orange; vertical-align:middle;'>warning</i> 
        ¡La IA puede cometer errores, revisa bien antes de guardar los resultados! </div><div><i class='material-icons' style='color:green; vertical-align:middle;'>check_circle</i> 
        <b>¡Análisis Completo!</b> Datos extraídos con éxito: A continuación te sugiero los resultados que obtuve:</div>`,
    "aiWarning1":"<i class='material-icons' style='color:#ffa000; vertical-align:middle;'>warning</i> ",
    "aiWarning2": `<br><div style='color:red; font-weight: bold; font-style: italic; text-align: center;'><i class='material-icons' style='color:Orange; vertical-align:middle;'>warning</i>
        He procesado los primeros 30 productos del archivo. Si hay más, ¡envíamelos por separado!</div>`,
    "aiError2": "<i class='material-icons' style='color:#ffa000; vertical-align:middle;'>warning</i> Hubo un error técnico en el servidor: ",
    "aiResponse_category_1":"Para crear los productos que detecté en tu archivo, posiblemente necesites estas categorías. <b>Modifícalas si es necesario.</b>",
    "aiResponse_category_2":"No es necesario crear categorías nuevas.",
    "aiResponse_brand_1":"Para crear los productos que detecté en tu archivo, posiblemente necesites estas marcas. <b>Modifícalas si es necesario.</b>",
    "aiResponse_brand_2":"No es necesario crear marcas nuevas.",
    "aiResponse_product_1":"Las marcas y categorías han sido procesadas, aquí tienes los productos que detecté. <b>¡Revísalos bien!</b>",
    "aiResponse_product_2":"<i class='material-icons' style='color:#ffa000; vertical-align:middle;'>info</i> Antes de a mostrarte los productos, !es necesario <b>CREAR</b> o <b>DESCARTAR</b> todas las categorías y marcas que te sugerí!",
    "aiResponse_product_3": "<i class='material-icons' style='color:#ffa000; vertical-align:middle;'>info</i> No detecté productos para sugerir."
}